<template>
  <modal :show-close="modalConfig.showClose"
         :wrapper-classes="modalConfig.wrapperClasses"
         @close="$emit('reject')">
    <h2 slot="header" class="modal-title text-3xl text-center sm:text-4xl mt-5 sm:mt-10">
      instant points
    </h2>
    <h4 slot="subHeader" class="text-xs text-gray-700 text-center font-light px-0 sm:px-10 sm:text-xl">
      configure an instant points offer where once sent to your members, the value you set below will automatically be added to their balance
    </h4>
    <instant-points-form
      slot="body"
      :instantPointsDraftState.sync="bonus_value"
    />
    <div slot="action" class="modal-action-click">
      <button class="button done-button" :disabled="isDoneButtonDisabled" @click="clickedDone()" data-cy="instant-points-done-button">done</button>
    </div>
  </modal>
</template>

<script>
import InstantPointsForm from "../forms/instant-points-form.vue";
import Modal from "../../../shared/Modal.vue";

export default {
  props: {
    campaign: Object,
    extension: Object
  },

  name: "instant-points-modal",

  components: {Modal, InstantPointsForm},

  data(){
    return {
      bonus_value: null,
      modalConfig: {
        showClose : true,
        wrapperClasses: ["extensions-modal","instant-points-modal"]
      }
    }
  },

  created() {
    this.bonus_value = this.extension.payload.bonus_value;
  },

  computed: {
    isDoneButtonDisabled() {
      return !this.bonus_value || this.bonus_value < 1;
    }
  },

  methods: {
    async clickedDone(){
      this.$emit('resolve', {
        type: 'InstantReward',
        bonus_value: this.bonus_value,
        bonus_type: 'add'
      });
    },
  }
}
</script>

<style scoped>
.instant-points-modal {
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-right: 10px;
  width: 100%;
}

.instant-points-modal span {
  font-size: 18px;
}

.instant-points-modal >>> .error {
  border-color: #f91253;
}

.instant-points-modal input {
  width: 100%;
}

.done-button {
  min-width: 10rem;
  top: 1rem !important;
}
</style>
